module.exports = __webpack_public_path__ + "img/25.8f36287c.jpg";